import React from "react";
import styles from "./awaitingPaymentButton.scss";
import { Button } from "antd";
import { ShoppingCartParsed } from "../../../../models";

export interface IAwaitingPaymentButtonProps {
  cart: ShoppingCartParsed;
  onAwaitingPayment: (cart: ShoppingCartParsed) => void;
}

const AwaitingPaymentButton = (props: IAwaitingPaymentButtonProps): JSX.Element => {
  const { cart, onAwaitingPayment } = props;

  return (
    <button
      type="primary"
      className={styles.button}
      onClick={() => onAwaitingPayment(cart)}
    >
      <span className={styles.text}>{"Upute za plaćanje"}</span>
    </button>
  );
};

export default AwaitingPaymentButton;



// WEBPACK FOOTER //
// ./src/containers/FinancePage/FinanceList/AwaitingPaymentButton/index.tsx